import { useState } from 'react';
import { CheckCircle2, Clock3, Mail, MessageSquareText, Search, TicketCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHero, PrototypeNotice, SectionIntro } from '../components/Sections';

const topics = [
  ['Ride request', 'Matching, pickup, fare or journey concern'],
  ['Courier order', 'Package, handover or delivery concern'],
  ['Captain account', 'Registration, documents or vehicle review'],
  ['Account access', 'Login, OTP, PIN or account recovery'],
];

export function Support() {
  const [submitted, setSubmitted] = useState(false);
  function submit(event) {
    event.preventDefault();
    setSubmitted(true);
  }

  return (
    <>
      <PageHero
        eyebrow="Sawwari support"
        title="Start with the right support path."
        text="Find the relevant topic, preserve a traceable reference and keep future replies connected to the same issue."
        tone="violet"
      />

      <section className="section">
        <div className="container support-search-wrap">
          <label className="support-search">
            <Search />
            <span className="sr-only">Search help topics</span>
            <input placeholder="Search rides, courier, documents or account access" />
          </label>
          <div className="support-topic-grid">
            {topics.map(([title, text]) => (
              <article key={title}><MessageSquareText /><h3>{title}</h3><p>{text}</p><button type="button">View topic <span>→</span></button></article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--soft" id="complaints">
        <div className="container support-form-grid">
          <div>
            <SectionIntro
              eyebrow="Complaints and support"
              title="Create one traceable record."
              text="The form demonstrates the structure for a ticket workflow without sending information to a live service."
            />
            <div className="support-points">
              <span><TicketCheck /><div><strong>Immutable reference</strong><p>Keep one ticket number throughout the conversation.</p></div></span>
              <span><Clock3 /><div><strong>Status visibility</strong><p>Show when an issue is open, awaiting information or resolved.</p></div></span>
              <span><Mail /><div><strong>Connected replies</strong><p>Keep customer and support messages in the same record.</p></div></span>
            </div>
            <Link className="text-link" to="/complaints">Read the complaints and resolution policy →</Link>
          </div>
          <form className="support-form" onSubmit={submit}>
            {submitted ? (
              <div className="support-success" role="status"><CheckCircle2 /><h2>Prototype ticket created</h2><p>No data was sent. Connect this form to the support API for production use.</p><button type="button" onClick={() => setSubmitted(false)}>Create another</button></div>
            ) : (
              <>
                <h2>Tell us what happened</h2>
                <label><span>Topic</span><select required defaultValue=""><option value="" disabled>Select a topic</option>{topics.map(([title]) => <option key={title}>{title}</option>)}</select></label>
                <label><span>Reference number <small>optional</small></span><input placeholder="Ride, order or ticket reference" /></label>
                <label><span>Your message</span><textarea rows="5" required placeholder="Describe the issue and the outcome you need" /></label>
                <label className="consent"><input type="checkbox" required /><span>I understand this prototype does not send or store my message.</span></label>
                <button className="button button--primary button--full" type="submit">Create prototype ticket</button>
              </>
            )}
          </form>
        </div>
        <div className="container"><PrototypeNotice>Connect identity, journey lookup, secure attachments, case assignment, audit logging and notification delivery before production.</PrototypeNotice></div>
      </section>
    </>
  );
}
